<template>
  <div class="infomationContent">
    <Nav></Nav>
    <div style="max-width: 1200px;width: 100%;height:80px;"></div>
    <div class="line_tabs">
        <div>首页</div>
        <i style="margin: 0 4px;" class="el-icon-arrow-right"></i>
        <div style="color: #721EDC;">资讯中心</div>
    </div>
    <div class="contentlist">
      <div class="left_box"  v-infinite-scroll="loadarticle" style="overflow-y:scroll">
          <div class="article_item" @click="readnews(item)" v-for="(item,index) in infomation" :key="index">
            <div class="newsimg">
              <img :src="item.articleInfo.articleHeadImg" alt="" srcset="">
            </div>
           <div class="big_rightbox">
             <div class="title" :class="item.articleUserRelation.viewState == 1?'Lookuser':''">
               {{item.articleInfo.articleTitle}}
             </div>
             <div class="samll_title myfont1">
                <div class="mytxt" v-html="item.articleInfo.Content"></div>
                <div class="savetxt"></div>
             </div>
             <div class="art_status">
               <div class="art_items">
                 <img src="/static/news/liulan.png" alt="" srcset="">
                 <span>{{item.articleExtra.viewNum}}</span>
               </div>
               <div class="art_items">
                 <img src="/static/center/pinglun.png" alt="" srcset="">
                 <span>{{item.articleExtra.commentNum}}</span>
               </div>
               <div class="times">
                   {{fiftime(item.articleInfo.createTime)}}
               </div>
             </div>
           </div>
          </div>
          <div class="emittxt">
              {{nomoretxt}}
          </div>
      </div>
      <div class="right_box">
          <div class="hot_title">热门资讯</div>
          <div class="hot_infomations"  v-infinite-scroll="load"  >
              <div class="hot_infomations_item"  @click="readnews(item)" v-for="(item,index) in Hotinfomation" :key="index">
                <div class="numbers" :class="'Activearticle'+index">{{index + 1}}</div>
                <div class="cont_txt myfont2" :class="item.articleUserRelation.viewState == 1?'Lookuser':''">
                   {{item.articleInfo.articleTitle}}
                </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Nav from '@/component/Nav'
  import $ from 'jquery'
  import moment from 'moment'
  import {articleinfo,relationList,viewArticle} from '@/api/video.js'
  export default {
    data() {
      return {
        key: 'value',
        nomoretxt:'加载中···',
        infomation:[],
        firstReqTime1:'',
        firstReqTime2:'',
        Hotinfomation:[],
        HotArticlePage:1,
        pageArticleIndex:1,
        deviceIdentify:'',
      }
    },
    created() {

    },
    methods:{
        readnews(item){
         if(localStorage.getItem("token")){
            // 上报资讯
            viewArticle({
              articleId:item.articleInfo.articleId,
            })
            item.articleUserRelation.viewState = 1
         }
         setTimeout(()=>{
           const neww = this.$router.resolve({
             path: "/news",
             query: { aid:item.articleInfo.articleId,rid:3 },
           });
           window.open(neww.href, "_self");
         },100)
        },
        initArticle(){
          articleinfo({
            deviceIdentify:'',
            firstReqTime: this.firstReqTime2,
            page:this.pageArticleIndex,
            limit:10
          }).then(res=>{
            if(res.data.code ==200){
              let arrlist = res.data.data.list;
              if(arrlist && arrlist.length>0){
                this.firstReqTime2 = res.data.data.firstReqTime;
                  arrlist.map(item=>{
                    if(item.articleInfo.articleContent){
                      item.articleInfo.Content = $(item.articleInfo.articleContent).text();
                      // item.articleInfo.Content =  item.articleInfo.articleContent.replace(/(<img).*?(>)/ig,'');
                      // item.articleInfo.Content = item.articleInfo.Content.replace(/(<br>)/ig,'')
                      // this.$nextTick(()=>{
                      //   console.log($('.samll_title').text());
                      // })
                    }
                  })
                  if(res.data.data.pageNum === 1){
                     this.infomation = arrlist;
                  }
                  if(res.data.data.pageNum > 1 && arrlist.length > 0 ){
                      this.infomation =  this.infomation.concat(arrlist);
                  }
              }else{
                console.log('没有数据了',arrlist);
                setTimeout(()=>{
                  this.nomoretxt = '到底了~'
                },500)
              }
            }
            console.log('资讯列表',this.infomation , this.firstReqTime);
          })
        },
        // 热门资讯
        initHotArticle(){
          articleinfo({
            firstReqTime: this.firstReqTime1,
            page:this.HotArticlePage,
            sortOrder:1,
            limit:10
          }).then(res=>{
            if(res.data.code ==200){
              this.firstReqTime1 = res.data.data.firstReqTime
              if(res.data.data.pageNum == 1){
                  this.Hotinfomation = res.data.data.list;
              }
              if(res.data.data.pageNum > 1 && res.data.data.list.length > 0 ){
                this.Hotinfomation.concat(res.data.data.list)
              }else{
               setTimeout(()=>{
                 this.nomoretxt = '到底了~'
               },500)
              }
            }

          })
        },
        loadarticle(){
            this.nomoretxt = '加载中···'
            console.log('加载2', this.pageArticleIndex);
            this.initArticle()
             this.pageArticleIndex++
        },
        load(){
          this.nomoretxt = '加载中···'
            console.log('加载1', this.HotArticlePage);
            this.initHotArticle();
            this.HotArticlePage++
        },
        fiftime(val){
        	let t1= moment(val * 1000);
        	let t2 = moment();
        	let status = '';
        	if(t2.diff(t1, 'day') > 0){
            let days =  t2.diff(t1, 'day');
            if(days >= 4){
              return moment(val * 1000).format('YYYY-MM-DD')
            }else{
              status = days +'天前'
              return status
            }

        	}
        	if(t2.diff(t1, 'hour') > 0){
        		status = t2.diff(t1, 'hour') +'小时前'
        		return status
        	}

        	if(t2.diff(t1, 'minutes') > 0){
        		status = t2.diff(t1, 'minutes') +'分钟前'
        		return status
        	}
        	if(t2.diff(t1, 'seconds') >= 0){
        		status = '刚刚'
        		return status
        	}
        	console.log();//实际相差多少天 ， 第二个参数是单位
        	 // moment(val * 1000).format('YYYY-MM-DD HH:mm:ss')
        },
    },
    components:{
      Nav
    }
  }
</script>
<style lang="scss" scoped>

  .infomationContent{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    // height: calc(100vh - 80px);
    background: #F7F8FA;

 /*每个页面公共css */
 .myfont1 {
 	overflow: hidden; //隐藏文字
 	text-overflow: ellipsis; //显示 ...
 	white-space: nowrap; //不换
 }
 .myfont2 {
 	    word-break: break-all;
 	    text-overflow: ellipsis;
 	    display: -webkit-box;
 	    -webkit-box-orient: vertical;
 	    -webkit-line-clamp: 2; /* 这里是超出几行省略 */
 	    overflow: hidden;
 }
    .btnActive:active{
    	opacity: .6;
    	transition: all .2s;
    }

    ::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 3px;
      /*高宽分别对应横竖滚动条的尺寸*/
      height: 8px;
    }

    ::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      //background-color: #8c8c8c;
      background-color: rgba(0, 0, 0, 0.25);
    }

    ::-webkit-scrollbar-track {
      background-color: #f6f6f6;
    }

    ::-webkit-scrollbar-thumb,
    ::-webkit-scrollbar-track {
      border: 0;
    }
    .contentlist{
      display: flex;
      width: 100%;
      max-width: 1200px;
      justify-content: space-between;
      .Lookuser{
       color: #999999 !important;
      }
      .left_box{
        width: 796px;
        background: #FFFFFF;
        padding: 0 24px;
        height: calc(100vh - 80px - 64px);

        .emittxt{
          padding: 20px;
          font-size: 14px;
          color: #666666;
          text-align: center;
        }
        .big_rightbox{


          height: 126px;
          margin-left: 6px;
          width: 100%;
          display: flex;
          max-width: calc(796px - 236px - 40px );
          flex-direction: column;
          justify-content: space-between;
          .title{
           font-size: 20px;
           font-family: PingFangSC-Medium, PingFang SC;
           font-weight: 500;
           color: #333333;
          }
          .samll_title{
            display: flex;
            font-size: 16px;
            width: 98%;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            div{
              display: flex;
            }
          }
          .art_status{
            display: flex;
            flex: 2;
            align-items: flex-end;
            .times{
              flex: 2;
              display: flex;
              justify-content: flex-end;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
            }
            .art_items{
              margin-right: 16px;
              display: flex;
              align-items: center;
              img{
                width: 14px;
                height: 14px;
              }
              span{
                margin-left:4px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
              }
            }
          }
        }
        .art_img{
         width: 224px;
         height: 126px;
          background: #c7c7c7;
          overflow: hidden;
          border-radius: 2px;
          position: relative;
          img{
             object-fit: cover;
           			background-size: cover;
           			background-repeat: no-repeat;
           			background-position: 50%;
           			position: absolute;
           			width: 100%;
           			height: 100%;
          }
        }
        .article_item:hover .title{
          color: #721EDC !important;
        }
        .article_item{
          height: 174px;
          padding:24px 0;
          box-sizing: border-box;
          cursor: pointer;
          display:flex;
          border-bottom: 1px solid rgba(0,0,0,0.1);
          .newsimg{
            margin-right: 12px;
            width: 224px;
            height: 126px;
            position: relative;
            img{
              object-fit: cover;
                       			background-size: cover;
                       			background-repeat: no-repeat;
                       			background-position: 50%;
                       			position: absolute;
                       			width: 100%;
                       			height: 100%;
            }
          }
        }
      }
      .right_box{
        width: 392px;
        background: #FFFFFF;
        padding:0 12px;
        box-sizing: border-box;
        .hot_infomations{
          border-top: 1px solid rgba(0,0,0,0.1);
          height: calc(100vh - 80px - 128px);
          overflow-y: scroll;
          .hot_infomations_item:hover{
            .cont_txt{

              color: #721EDC !important;
            }
          }
          .hot_infomations_item{
            flex: 2;
            margin-top: 12px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            padding: 12px;
            cursor: pointer;
            // max-height: 68px;
            background: #F8F7F9;
            border-radius: 2px;
            .Activearticle0{
              color: #ED1010 !important;
            }
            .Activearticle1{
              color: #E58000 !important;
            }
            .Activearticle2{
              color: #EDB210 !important;
            }
            .cont_txt{
              width: 307px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #363636;
            }
            .numbers{
              width: calc(50px - 12px);
              // line-height:44px;
              font-size: 24px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #DADADA;
            }
          }
        }
        .hot_title{
          text-align: left;
          width: 80px;
          height: 60px;
          line-height: 60px;
          border-bottom: 2px solid #721EDC;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #333333;
        }
      }
    }
  }
  .line_tabs{
    margin: 12px 0;
    max-width: 1200px;
    width: 100%;
    display: flex;
    padding:12px 24px;
    box-sizing: border-box;
    align-items: center;
    height: 40px;
    background: #FFFFFF;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
</style>



// WEBPACK FOOTER //
// src/pages/template/informationlist.vue